export const isKariBday = () => {
  const today = new Date();
  return today.getMonth() === 4 && today.getDate() === 25; // 25 de mayo
};

export const isKarimeSaysAnniversaryWeek = () => {
  const now = new Date();
  const start = new Date(2026, 4, 26); // 26 mayo, medianoche local
  const end = new Date(2026, 5, 2); // 2 junio, medianoche local
  return now >= start && now < end;
};

// Las votaciones cierran en hora de la Ciudad de México.
const TZ = "America/Mexico_City";

// "2026-11-18T05:59:59Z" -> "17 de noviembre" (fecha en CDMX)
export const formatSpanishDate = (iso) => {
  if (!iso) return "";
  return new Intl.DateTimeFormat("es-MX", {
    day: "numeric",
    month: "long",
    timeZone: TZ,
  }).format(new Date(iso));
};

export const hasEnded = (iso) => new Date() > new Date(iso);

// "YYYY-MM-DD" de una fecha, en CDMX.
const mxDay = (date) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(date);

// Diferencia en días de calendario (CDMX) entre hoy y `iso`. 0 = hoy es el
// último día, negativo = ya pasó.
export const daysUntil = (iso) =>
  Math.round((Date.parse(mxDay(new Date(iso))) - Date.parse(mxDay(new Date()))) / 86400000);
